import { render, staticRenderFns } from "./FormMarketplaceTemplate.vue?vue&type=template&id=11abae8b&scoped=true"
import script from "./FormMarketplaceTemplate.vue?vue&type=script&lang=js"
export * from "./FormMarketplaceTemplate.vue?vue&type=script&lang=js"
import style0 from "./FormMarketplaceTemplate.vue?vue&type=style&index=0&id=11abae8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11abae8b",
  null
  
)

export default component.exports